let offerCode = {
    code: 'ABCD',
    disCount: 20,
}

let sendPrice = 10_000;

export default offerCode

export {sendPrice}